module.exports = __webpack_public_path__ + "img/coupon_footer.daaba279.png";